export type { CenteredFormCardProps } from './CenteredFormCard.types'
export { default as CenteredFormCard } from './CenteredFormCard'